import { atom } from "jotai";


export const unloCkedChaptersAtom = atom<number>(0);

export const completedChaptersAtom = atom<number[]>([]);

export const newChapterUnlockedAtom = atom<boolean>(false);

export const chapter51ComingUpAtom = atom<boolean>(false);